export default {
    custom: {
        search: 'Search',
        placeholder: 'Please enter the tag',
        all: 'All',
        noTag: 'No tag',
        nickname: 'Customer nickname/remark ',
        addTime: 'Add date',
        lastConversationTime: 'Last conversation date',
        searchPlaceholder: 'Please enter the search',
        to: 'to',
        startDate: 'Start date',
        endDate: 'End date',
        client: 'Client ',
        account: 'Account ',
        query: 'Query',
        syncCustomer: 'Sync customer',
        addTag: 'Add tag',
        manualAdd: 'Manual add',
        aiAdd: 'AI add',
        nickname1: 'Customer nickname',
        company: 'Company name',
        tag: 'Tag',
        clickAddTag: 'Click to add tag',
        wx: 'WeChat',
        gender: 'Gender',
        remark: 'Customer remark',
        operation: 'Operation',
        detail: 'Detail',
        goChatManage: 'Go to chat management',
        basicInfo: 'Basic information',
        tagInfo: 'Tag information',
        handTags: 'Hand add',
        aiTags: 'AI add',
        noTag1: 'No tag',
        manualAdd1: 'Manual add',
        aiTagSetting: 'AI tag setting',
        aiTagSetting1: 'After selecting the tag, AI will judge whether the user satisfies the "tag description" of the selected tag based on the user\'s historical conversation record. If it satisfies, it will be tagged.',
        aiTagSetting2: 'AI tagging requires a certain amount of time, and the tagging result can be viewed in the customer list after completion.',
        selectTag: 'Select tag ',
        selectCustomer: 'Please select the customer to add the tag',
        syncCustomerSuccess: 'Sync customer success',
        userDetial: {
            nickname: 'Customer nickname',
            company: 'Company name',
            remark: 'Customer remark',
            customerType: 'Customer type',
            gender: 'Gender',
            addTime: 'Add time',
            lastConversationTime: 'Last conversation time',
        },
        aiTagSuccess: 'AI tag success',
        tagSuccess: 'Tag success',
        customerList: 'Customer list',
        tagManage: 'Tag management',
        searchTag: 'Enter tag name search',
        createTag: 'Create tag', 
        tagName: 'Tag name',
        tagDescription: 'Tag description',
        tagGroup: 'Tag group',
        syncThirdPlatform: 'Sync third platform',
        createUsername: 'Create username',
        createTime: 'Create time',
        tagGroup1: 'Tag group',
        syncThirdPlatform1: 'Sync third platform',
        edit: 'Edit',
        delete: 'Delete',
        createGroup: 'Create group',
        groupName: 'Group name',
        editTag: 'Edit tag',
        createTag1: 'Create tag',
        editTag1: 'If you modify the "tag name", the corresponding tag of the customer will also be renamed; if the tag is set to synchronize to the third platform, the third platform tag will not be renamed.',
        editTag2: 'If you modify the "tag description", the AI will use the latest tag description to tag, and the customers will not be changed.',
        editTag3: 'If you modify the synchronization settings, new customers will be tagged according to the latest rules (or stop synchronization), and historical customers will not be synchronized.',
        editTag4: 'The tag description is very important. When using the AI tagging function, it will match the tag description and the customer\'s historical conversation with AI to tag, please use specific and clear language to describe the tag.',
        tagName1: 'Tag name ',
        tagDescription1: 'Tag description ',
        placeholderTagName: 'Please enter the tag name',
        placeholderTagDescription: 'Please enter the tag description',
        tagGroup2: 'Tag group ',
        tagSync: 'Tag synchronization ',
        tagSync1: 'Synchronize to WeWork',
        tagSync2: 'After selecting, if the customer of the WeWork account is added to the tag',
        tagSync3: 'The tag will be synchronized to the official customer personal tag of WeWork',
        tagSync4: 'Synchronize to WeChat',
        tagSync5: 'After selecting, if the friend of the WeChat account is added to the tag',
        tagSync6: 'The tag will be synchronized to the official friend tag of WeChat',
        editGroup: 'Edit group',
        createGroup1: 'Create group',
        groupName1: 'Group name ',
        placeholderGroupName: 'Please enter the group name',
        createGroupSuccess: 'Create group success',
        editGroupSuccess: 'Edit group success',
        deleteGroup: 'Are you sure you want to delete this group?',
        deleteGroupSuccess: 'Delete group success',
        deleteSuccess: 'Delete success',
        deleteTag: 'Are you sure you want to delete this tag?',
        deleteTagSuccess: 'Delete tag success',
        pleaseEnterTagName: 'Please enter the tag name',
        pleaseEnterTagDescription: 'Please enter the tag description',
        editTagSuccess: 'Edit tag success',
        createSuccess: 'Create success',
    }
}